module.exports = __webpack_public_path__ + "img/1-3.164dcf08.svg";